import React from 'react';
import { X } from 'lucide-react';
import { useNotifiche } from '../utils/notifiche';
import '../styles/Notifiche.css';

/**
 * La coda delle notifiche, montata una volta sulla radice (App.js):
 * c'e' anche sul tablet e sulle pagine senza Layout, cosi' un errore
 * arriva ovunque sia successo. Il disegno e' rm-messaggio.
 */
const Notifiche = () => {
    const voci = useNotifiche((s) => s.voci);
    const togli = useNotifiche((s) => s.togli);
    if (!voci.length) return null;
    return (
        <div className="ntf-coda" role="status" aria-live="polite">
            {voci.map((v) => (
                <div key={v.id} className={`rm-messaggio rm-messaggio-${v.tipo} ntf-voce`}>
                    <span>{v.testo}</span>
                    <button type="button" className="ntf-chiudi" onClick={() => togli(v.id)} aria-label="Chiudi">
                        <X size={14} />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default Notifiche;
